import { ReactNode } from 'react';

export function explainTopP() : ReactNode
{
    return <>
        <p>Also known as "nucleus sampling," this parameter controls the diversity of responses
           by limiting the model to consider only the most probable tokens whose cumulative probability reaches the specified threshold.</p>
        <ul>
            <li>0.1 - Very focused, only highly probable tokens</li>
            <li>0.5 - Moderately diverse output</li>
            <li>1.0 - Considers all tokens based on their probability</li>
        </ul>
        <p><strong>Note:</strong> It's generally recommended to adjust either temperature OR top_p,
            but not both simultaneously. When top_p is less than 1.0, the model samples from the
            smallest set of tokens whose cumulative probability exceeds the threshold.</p>
        </>;
}

